import { useState, useEffect, useRef } from "react";
import { setProgressLoadingFunctions } from "config/ProgressLoaderManager";
import { ProgressBar } from "react-bootstrap";

const LoaderProgressManager = () => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    const startLoading = () => {
      setLoading(true);
      setProgress(10);

      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev < 90) {
            return prev + 10;
          } else {
            clearInterval(intervalRef.current);
            return prev;
          }
        });
      }, 200);
    };

    const stopLoading = () => {
      clearInterval(intervalRef.current);
      setProgress(100);
      setTimeout(() => {
        setLoading(false);
        setProgress(0);
      }, 400);
    };

    setProgressLoadingFunctions(startLoading, stopLoading);

    return () => clearInterval(intervalRef.current);
  }, []);

  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "2px",
        width: "100%",
        zIndex: 5000,
      }}
    >
      <ProgressBar
        now={progress}
        animated
        striped
        variant="success"
        style={{ height: "2px", marginBottom: 0 }}
      />
    </div>
  );
};

export default LoaderProgressManager;
